// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".App-layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n.App-content {\n  padding-top: 34px;\n  flex-grow: 1;\n}\n", "",{"version":3,"sources":["App.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd","file":"App.less","sourcesContent":[".App-layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n.App-content {\n  padding-top: 34px;\n  flex-grow: 1;\n}\n"]}]);
// Exports
module.exports = exports;
